import { BaseEntity, Transform, toDate } from './base';

export class VehicleMakeModel extends BaseEntity {
  id: number;
  make: string;
  isHidden: boolean;

  @Transform(toDate)
  createdAt: Date;

  @Transform(toDate)
  updatedAt: Date;
}



// WEBPACK FOOTER //
// ./src/models/vehicle-make.ts